import { useContext, useState } from 'react'
import { Box, Skeleton, Stack, SvgIcon, Typography } from '@mui/material'
import { DataContext } from '../../../contexts/data/dataContext'
import { 
  gridIconPath,
  greenBatteryChargingIcon,
  greenBatteryDischargingIcon,
  greenBatteryFullIcon,
  greenBatteryLowIcon
} from '../../../components/common/iconPaths'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics } from '../../common/util/util'

export default function TouMessage() {
  const data: any = useContext(DataContext)
  const [showMore, setShowMore] = useState(false);

  const handleShowMore = ()=>{
    setShowMore(true)
    sendClickAnalytics('/dashboard', {
        domain: analyticsDomain.dashboard,
        name: analyticsCta.energyFlowDescription,
        metadata: {},
    })
  }

  const batteryIcons: any = {
    "On reserve":  greenBatteryLowIcon,
    "Charging": greenBatteryChargingIcon,
    "Discharging": greenBatteryDischargingIcon,
    "Full": greenBatteryFullIcon,
  }

  if(!data?.dashboard?.energyFlow) 
    return (
      <Box my={1}  mx={2} width="100%" >
        <Skeleton variant="rectangular" 
          sx={{ borderRadius: '16px',  
          height: "15vh"
        }}/>
      </Box>
    )

  return (
    <Box>   
        <Box mt={custom.spacing.xxs} 
             width="100%">
          <Typography id="touTitle" 
              variant="szHeading.Bold.xLarge"  
              >
              {data?.dashboard?.tou?.title || 'Energy Flow'}
          </Typography>
          {!showMore ?
            <>
              <Typography id="energyFlowDesc" 
                  component="p"
                  mt={custom.spacing.xxxs}  
                  variant="szBody.Regular.Medium" >
                  {data?.dashboard?.tou?.description?
                  `${data?.dashboard?.tou?.description}..`:''}
              </Typography>
              <Typography id="touShowMore" 
                  onClick={handleShowMore}
                  component="p"
                  mt={custom.spacing.xxxs} 
                  color='primary.main'
                  variant="szBody.Regular.Medium" 
                  sx={{
                    cursor: 'pointer'
                  }}>
                  Show more
              </Typography>
            </>
          : 
            <Box mt={custom.spacing.xxxs}> 
              {`${data?.dashboard?.tou?.moreDescription || data?.dashboard?.tou?.description}`
                .split('\n').map((desc: string, i: number)=>(
                  <Typography id={`touDescriptionGroup${i+1}`} 
                    component="p"
                    key={i} 
                    mb={custom.spacing.sm}
                    variant="szBody.Regular.Medium" >
                      {desc}
                  </Typography>
                ))
              }
            </Box>
          }
        </Box>
        <Box mt={custom.spacing.sm} >
          <Stack direction="row" alignItems="center">
              <SvgIcon viewBox='0 0 24 24'>
                  {gridIconPath}
              </SvgIcon>
              <Typography variant="szBody.Regular.Small"
                    id="touGridTitle">
                    {data?.dashboard?.tou?.grid.title}
                    <Typography variant="szBody.Regular.xSmall"
                        id="touGridSubTitle">
                        <br/>{data?.dashboard?.tou?.grid.subTitle}
                    </Typography>
              </Typography>
              <SvgIcon viewBox='0 0 24 24' 
                  sx={{ ml: custom.spacing.md }}>
                  {batteryIcons[data?.dashboard?.tou?.battery.title] 
                    || greenBatteryChargingIcon}
              </SvgIcon>
              <Typography variant="szBody.Regular.Small" 
                  id="touBatteryTitle"
                  ml={custom.spacing.xxs}>
                    {data?.dashboard?.tou?.battery.title}
                    <Typography variant="szBody.Regular.xSmall"
                        id="touBatterySubTitle">
                        <br/>{data?.dashboard?.tou?.battery.subTitle}
                    </Typography>
              </Typography>
          </Stack>
        </Box>
    </Box>      
  )
}
